import React from "react";

function ComponentNotFound({ componentName }) {
  return <div>Component {componentName} is not defined</div>;
}

export default ComponentNotFound;
